module.exports = __webpack_public_path__ + "static/media/crisalyde-large-white.39582c4f.png";